import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-car-spinner',
  templateUrl: './car-spinner.component.html',
  styleUrls: ['./car-spinner.component.scss']
})
export class CarSpinnerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
